import { IonCol, IonRow, useIonAlert } from '@ionic/react'
import moment from 'moment'
import React, { FC } from 'react'
import { FocusedActionKind } from '../../../hooks/terrain-mapping/helpers/StateReducers'
import { useTerrainMapping } from '../../../hooks/terrain-mapping/useTerrainMapping'
import { ListContainer } from '../../consultant/StyledContainers'
import { BlueButton, RedButton } from '../../incident-management/StyledContainers'
import EngagementScreen from '../popovers/EngagementScreen'
import { getColor } from './FlashpointList'
import axios from 'axios'
import { useWorkspace } from '../../../hooks/useWorkspace'

const EngagementList : FC = () => {
  const { engagementNotes, setEngagementNotes, focusedElems, dispatchFocused, loading, setLoading, filteredEngagementNotes } = useTerrainMapping()
  const { workspace } = useWorkspace()
  const [ionAlert] = useIonAlert()

  if (focusedElems.focusedEngagement) {
    return (
      <EngagementScreen />
    )
  }

  const handleDelete = (e: { id: string }) => {
    ionAlert({
      header: 'Confirmation',
      message: 'Are you sure you want to delete this Engagement Note?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            console.log('Delete canceled')
          },
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Delete', e)
            setLoading(true)
            axios.put('/api/v2/engagement_note/delete_note', {
              domain_id: workspace.id,
              note_id: e.id,
            }).then(({ data }) => {
              setEngagementNotes((prevNotes) => prevNotes.filter((note) => note.id !== Number(e.id)))
              console.log('Success:', data)
              // Handle success case here
            }).catch((error) => {
              console.error('Error:', error)
              // Handle error case here
            }).finally(() => {
              setLoading(false)
            })
          },
        },
      ],
    })
  }

  return (
    <ListContainer style={{ backgroundColor: 'white', height: '100%' }}>
      <div style={{ height: '100%', overflow: 'hidden' }} className='risk-assessment-list'>
        <IonRow style={{ padding: '10px' }} className='terrain-list-title  ion-justify-content-between ion-align-items-center'>
          <IonCol size='2'>
            <h5>Subject</h5>
          </IonCol>
          <IonCol size='2'>
            <h5>Type</h5>
          </IonCol>
          <IonCol size='2'>
            <h5>Aim</h5>
          </IonCol>
          <IonCol size='2'>
            <h5>Associated Community</h5>
          </IonCol>
          <IonCol size='2'>
            <h5>Date</h5>
          </IonCol>
          <IonCol size='2' />
        </IonRow>
        <div style={{ flex: 1, overflow: 'auto' }}>
          {
            filteredEngagementNotes.sort((a, b) => new Date(b.date) - new Date(a.date)).map((val, index) => (
              <IonRow
                className='ion-justify-content-between terrain-register-row ion-align-items-center'
                style={{ backgroundColor: getColor(index) }}
                key={val.id}
              >
                <IonCol
                  size='2'
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre-wrap',
                    cursor: 'pointer'
                  }}
                  title={val.subject}
                >
                  { val.subject }
                </IonCol>
                <IonCol size='2'>{ val.type }</IonCol>
                <IonCol size='2'>{ val.aim }</IonCol>
                <IonCol size='2'>{ val?.community?.name }</IonCol>
                <IonCol size='2'>{ moment(val.date).format('DD/MM/YY') }</IonCol>
                <IonCol size='2'>
                  <BlueButton onClick={() => dispatchFocused({ type: FocusedActionKind.SELECT_ENGAGEMENT, engagement: val })}>View</BlueButton> /
                  <RedButton onClick={() => handleDelete(val)} disabled={loading}>Delete</RedButton>
                </IonCol>
              </IonRow>
            ))
          }
          {
            engagementNotes.length === 0 && (
              <p style={{ textAlign: 'center' }}>No engagement notes available</p>
            )
          }
        </div>
      </div>
    </ListContainer>
  )
}

export default EngagementList
